import { HttpHandler, HttpInterceptor, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, finalize, switchMap, take } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { LoaderService } from '../loader/loader.service';
import { AuthService } from "@easyfo/common-lib";

@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  constructor(
    public _loaderService: LoaderService,
    private firebaseAuth: AngularFireAuth,
    private authService: AuthService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this._loaderService.isLoading.next(true);

    /**
     * ถ้า url ไม่มี /api/ ไม่ต้องใช้ xtoken
     */
    if (req.url.indexOf('/api/') == -1) {
      return next
        .handle(req)
        .pipe(finalize(() => this._loaderService.isLoading.next(false)));
    }

    return this.firebaseAuth.idToken.pipe(
      take(1), // <-------------- only emit the first value!
      switchMap((token: any) => {
        if (token) {
          req = req.clone({
            setHeaders: {
              xtoken: token
            },
          });
        }
        return next
          .handle(req)
          .pipe(
            catchError<any, any>((e: HttpErrorResponse) => {
              if (e && e.headers.get('closeday_state')) {
                this.authService.handleCloseDay(e);
                return;
              }
              this.authService.handleSessionExpired(e);
              // return e;
              return throwError(() => e.error);
            }),
            finalize(() => this._loaderService.isLoading.next(false)));
      })
    );
  }
}
